import React, { useEffect, useState } from "react";
import { applyTheme, getCompanyTheme } from "../services/api/themeHandler";
import { useGlobalContext } from "./GlobalContext";
import { CONSTANTS } from "../constants/Constants";

const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useGlobalContext();
  const [themeApplied, setThemeApplied] = useState(false);

  useEffect(() => {
    const fetchCompanyTheme = async () => {
      try {
        if (user?.token) {
          const res = await getCompanyTheme();
          if (res?.success && res.data) {
            const themeColors = res.data;
            
            applyTheme({
              primary: themeColors.primaryColor || CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR,
              secondary: themeColors.secondaryColor || CONSTANTS.APP_DEFAULT_COLORS.SECONDARY_COLOR,
              tertiary: themeColors.tertiaryColor || CONSTANTS.APP_DEFAULT_COLORS.TERTIARY_COLOR,
            });
            setThemeApplied(true);
            return;
          }
        }

        applyTheme({
          primary: CONSTANTS.APP_DEFAULT_COLORS.PRIMARY_COLOR,
          secondary: CONSTANTS.APP_DEFAULT_COLORS.SECONDARY_COLOR,
          tertiary: CONSTANTS.APP_DEFAULT_COLORS.TERTIARY_COLOR,
        });
        setThemeApplied(true);

      } catch (error) {
        console.error("Error fetching theme:", error);
      }
    };

    fetchCompanyTheme();

  }, [user?.token]); 

  return themeApplied ? <>{children}</> : null;
};

export default ThemeProvider;
